import { render, staticRenderFns } from "./FullView.vue?vue&type=template&id=4fd7cb06&scoped=true"
import script from "./FullView.vue?vue&type=script&setup=true&lang=js"
export * from "./FullView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FullView.vue?vue&type=style&index=0&id=4fd7cb06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd7cb06",
  null
  
)

export default component.exports